const captcha = {
  recaptcha: 'reCAPTCHA verification failed. Please try again.',
  recaptchaNotAvailable:
    'Unable to complete verification. Please refresh the page and try again.',
  recaptchaInvalid: 'Verification failed. Please try again.',
  recaptchaUnexpected:
    'Unable to complete your request. Please try again later.',
};

export default captcha;
